import React from 'react'
import Result from './result'
import Typography from '@mui/material/Typography'

const leadsCRM = () => {
  return (
    <div>
        <Result/>
    </div>
  )
}

export default leadsCRM